export const FEATURE_FLAG_NAMESPACE = 'CONTENT-UPLOAD';
